import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const CallUsIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect x="0" y="0" width="24" height="24" />
        <path
          fill={color}
          {...color !== "currentColor" && { fillOpacity: ".65" }}
          fillRule="nonzero"
          d="M13.6346466,16.1541466 C14.6109088,15.1778845 16.1934912,15.1778845 17.1696701,16.1540633 L19.2919795,18.2753729 C20.2680156,19.2526587 20.2680156,20.8352413 19.2916016,21.8104052 L18.1271043,22.9739021 C16.9535357,24.1498039 15.1112383,24.334309 13.7243767,23.416739 C8.55628422,19.9986402 4.00024878,15.4426048 0.583153271,10.2755116 C-0.335354484,8.88666249 -0.151863125,7.04865634 1.02464661,5.87214661 L2.18864661,4.70814661 C3.16390876,3.73288446 4.74849124,3.73288446 5.72367005,4.70806329 L7.84597981,6.82937317 C8.82094006,7.80558338 8.82094006,9.38881662 7.84597981,10.3650268 L7.84575339,10.3652534 L7.46058399,10.7504228 C9.18451287,12.8103957 11.1861854,14.8118396 13.2495481,16.5392452 L13.6346466,16.1541466 Z M7.13872995,7.53633671 L5.01664661,5.41525339 C4.43190876,4.83051554 3.48049124,4.83051554 2.89575339,5.41525339 L1.73175339,6.57925339 C0.891635087,7.41937169 0.760681463,8.73111502 1.41725168,9.72389591 C4.76015122,14.7787952 9.22011578,19.2387598 14.2760904,22.5827054 C15.266653,23.2380776 16.582124,23.1063339 17.4197984,22.2669948 L18.5848732,21.1029202 C19.1703844,20.5181587 19.1703844,19.5687413 18.5847299,18.9823367 L16.4626466,16.8612534 C15.8769088,16.2755155 14.9274912,16.2755155 14.3417534,16.8612534 L13.6347534,17.5682534 C13.4530135,17.7499933 13.1630913,17.7643445 12.9642915,17.6014415 C10.6107027,15.6728343 8.32265683,13.3850497 6.398377,11.035509 C6.23555629,10.8367054 6.24994152,10.5468517 6.43164661,10.3651466 L7.13852537,9.65826785 C7.72345993,9.07246942 7.72342489,8.12178154 7.13872995,7.53633671 Z M12,1 C11.7238576,1 11.5,0.776142375 11.5,0.5 C11.5,0.223857625 11.7238576,0 12,0 C18.6281424,0 24,5.37185763 24,12 C24,12.2761424 23.7761424,12.5 23.5,12.5 C23.2238576,12.5 23,12.2761424 23,12 C23,5.92414237 18.0758576,1 12,1 Z M12,5 C11.7238576,5 11.5,4.77614237 11.5,4.5 C11.5,4.22385763 11.7238576,4 12,4 C16.4184775,4 20,7.58119268 20,12 C20,12.2761424 19.7761424,12.5 19.5,12.5 C19.2238576,12.5 19,12.2761424 19,12 C19,8.13349805 15.8662133,5 12,5 Z M12,9 C11.7238576,9 11.5,8.77614237 11.5,8.5 C11.5,8.22385763 11.7238576,8 12,8 C14.2094657,8 16,9.7901809 16,12 C16,12.2761424 15.7761424,12.5 15.5,12.5 C15.2238576,12.5 15,12.2761424 15,12 C15,10.3425098 13.6572252,9 12,9 Z"
        />
      </g>
    </g>
  </svg>
);

CallUsIcon.displayName = "CallUsIcon";

CallUsIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

CallUsIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default CallUsIcon;
